<template>
  <div class="confirmation-page">
		<h1 class="left-align"><v-icon x-large color="success">done</v-icon> Respondent Accounts have been created!</h1>
		<br>
		<h2 class="left-align">Next steps:</h2>
		<v-row>
			<v-col :cols="8">
				<p class="p3 left-align">1)	Save the Usernames and Passwords file to your computer - this file includes usernames and passwords to be distributed to your respondents.</p>
				<a @click="downloadFile(fileNameRespondents)">Download and save the usernames and passwords file</a>
			</v-col>
		</v-row>
		<v-row v-if="fileNameSchedule">
			<v-col :cols="8">
				<p class="p3 left-align">Save the User Schedule file to your computer - this file includes the scheduled recall dates for each user.</p>
				<a @click="downloadFile(fileNameSchedule)">Download and save the user schedule file</a>
			</v-col>
		</v-row>
		<v-row>
			<v-col :cols="8">
				<p class="p3 left-align">2)	Go to <a @click="goTo('Track Respondents')">Study Activity</a> to view upcoming scheduled recalls and track respondent activity.</p>
			</v-col>
		</v-row>
		<v-row>
			<v-col :cols="8">
				<p class="p3 left-align">3)	To make changes or access the username and password file again, go to <a @click="goTo('View Past Respondent Files')">View Past Respondent Files.</a></p>
			</v-col>
		</v-row>
		<v-btn class="btn-default" text @click="goTo('View Past Respondent Files')">Continue</v-btn>
  </div>
</template>

<script>
import { utilityService } from '@/services/utilityService';
import { researcherApiService } from '@/services/researcherApiService';
export default {
	name: 'ConfirmationPage',
	props: {
		// fileName: String
		fileNameRespondents: String,
		fileNameSchedule: String
	},
	methods: {
		async goTo (tabName) {
			const tabsPos = await utilityService.getTabsPositionByName(tabName, this.$studyTabConfig);
			const tabs = { tabIndex: tabsPos.tabPos, subTabIndex: tabsPos.subtabPos };
			this.$store.commit('setCurrentStudyTab', tabs);
			this.$router.push('/study/home');
		},
		downloadFile (fileName) {
			const me = this;
			researcherApiService.loadFile(this.$store.getters.getSelectedStudy.studyUuid, fileName)
				.then(function (response) {
					if (response) {
						const url = window.URL.createObjectURL(new Blob([response.data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
					}
				}).catch(function (error) {
					// Show an error message to the user
					me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: 'There was an error downloading the file.' });
				});
		}
	}
}
</script>
<style>
</style>
